import { render, staticRenderFns } from "./VendorBusinessProfile.vue?vue&type=template&id=31b47fe2&"
import script from "./VendorBusinessProfile.vue?vue&type=script&lang=js&"
export * from "./VendorBusinessProfile.vue?vue&type=script&lang=js&"
import style0 from "./VendorBusinessProfile.vue?vue&type=style&index=0&id=31b47fe2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports